import { Center, Modal } from "@mantine/core"
import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useReopenRequestMutation } from "~/pages/SupplierPortal/TraceabilityRequests/hooks.ts"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  requestId: number
  mode: "clean" | "dirty"
  opened: boolean
  onClose: () => void
}

export const ReopenRequestModal = ({
  requestId,
  mode,
  opened,
  onClose,
}: Props) => {
  const { t } = useTranslation(["traceability"])
  const { mutate: reopen, isPending: isLoading } = useReopenRequestMutation({
    onSuccess: (data) => {
      showSuccessNotification({
        title: "Feedback",
        message: t("reopenRequest.feedback", { count: data.count }),
      })
      onClose()
    },
    onError: (error: unknown) => {
      showAxiosError({
        notificationTitle: "Feedback",
        notificationMessage: t("reopenRequest.error"),
        showNotification: true,
        error: error as Error,
      })
    },
  })

  return (
    <>
      <Modal
        opened={opened}
        onClose={onClose}
        title={t("reopenRequest.title")}
        centered
      >
        <Center>
          <Button
            onClick={() => {
              reopen({ requestId, mode })
            }}
            loading={isLoading}
            color="yellow"
            variant="secondary"
          >
            {t("reopenRequest.yes")}
          </Button>
        </Center>
      </Modal>
    </>
  )
}
